import { useLoaderData } from "@remix-run/react";
import { loader } from "../../routes/_index";
import { getTrustpilotSkusForProductData } from "./get-trustpilot-skus-for-product-data";
import { TRUSTPILOT_CONSTANTS } from "../../components/features/trustpilot/trustpilot-constants";
import { fetchTrustpilotProductReviews } from "./fetch-trustpilot-product-reviews";
import { useBffClient } from "../../hooks/use-bff-client";
import { useEffect, useState } from "react";
import { type TrustpilotDisplayData } from "@made-people/grease-trustpilot";

export function useTrustpilotPdpData() {
  const {
    pageResponse: { page, frontendContext },
  } = useLoaderData<typeof loader>();
  const bffClient = useBffClient();
  const [trustpilotProductReviews, setTrustpilotProductReviews] =
    useState<TrustpilotDisplayData | null>(null);
  const [trustpilotProductSku, setTrustpilotProductSku] = useState<
    string | undefined
  >(undefined);

  useEffect(() => {
    async function load() {
      if (
        page.pageType !== "centraProductPage" ||
        !("productData" in page) ||
        !page.productData
      ) {
        return;
      }

      const skuString = getTrustpilotSkusForProductData(page.productData).join(
        ",",
      );
      setTrustpilotProductSku(skuString);

      if (skuString) {
        const reviews = await fetchTrustpilotProductReviews(bffClient, {
          productSku: skuString,
          language: frontendContext.language,
          perPage: TRUSTPILOT_CONSTANTS.REVIEWS_PER_PAGE_INITIAL,
          page: 1,
        });
        setTrustpilotProductReviews(reviews);
      }
    }

    load();
  }, [page, frontendContext.language, bffClient]);

  return {
    trustpilotProductSku,
    trustpilotProductReviews,
  };
}
